import React from 'react'

const Footwear = () => {
  return (
    <div>Footwear</div>
  )
}

export default Footwear